import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { playStyles } from '../../../../../shared/action/ActionModel';
import { Dropdown } from "../../../editor/Dropdown";
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { isBlank } from "../../../../../shared/helper/generalHelpers";
import { ElementGroup, ElementLabel } from './BaseElements';
export const PlayStyleSelectionActionDetail = observer(({
  parentTree,
  name,
  value,
  valueSetter,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const parameters = parentTree.treeParameterActions("actions/PlayStyleValueModel").map(p => formatTreeParameter(p.name));
  const options = ["", ...playStyles, ...parameters];
  const optionsLiterals = ["", ...playStyles.map(f => t("content.play_style_" + f)), ...parameters];
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(Dropdown, {
    className: !allowBlankValue && isBlank(value) ? "invalid" : "",
    value: value,
    onChange: ({
      target
    }) => valueSetter(target.value)
  }, options.map((o, index) => /*#__PURE__*/React.createElement("option", {
    key: o,
    value: o
  }, optionsLiterals[index]))));
});